import { makeStyles } from 'tss-react/mui';

import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'SocialButton' })((theme) => {
    return {
        root: {
            display: 'flex',
            padding: 12,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 16,
            color: '#8E8E8E',
            background: isLightMode(theme) ? '#FFF' : 'rgba(0, 0, 0, 0.50)',
            transition: 'all 0.2s',
            '&:hover': {
                background: 'rgba(0, 0, 0, 0.2)'
            },
            '&:active': {
                background: 'rgba(0, 0, 0, 0.2)'
            }
        }
    };
});
